import { SaleDocumentKind } from "@skylab-shared/dataModel";

export class OrderSaleDocumentDTO {
	id: string;
	kind: SaleDocumentKind;
	saleDocExternalId: string;
	saleDocNumber: string;
}